import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { approveTempReward, rejectTempReward } from '../../services/api';

const errMessage = (e, fallback) => e?.message || e?.status?.message || fallback;

// arg: ledgerId
export const approvePendingReward = createAsyncThunk(
    'rewardLedgerAction/approve',
    async ({ledgerId,bill }, { rejectWithValue }) => {
        try {
            const res = await approveTempReward(ledgerId, bill);
            return { ledgerId, message: res?.message || 'Reward approved successfully' };
        } catch (e) {
            return rejectWithValue(errMessage(e, 'Unable to approve reward'));
        }
    }
);

// arg: { ledgerId, reason }
export const rejectPendingReward = createAsyncThunk(
    'rewardLedgerAction/reject',
    async ({ ledgerId, reason }, { rejectWithValue }) => {
        try {
            const res = await rejectTempReward(ledgerId, reason);
            return { ledgerId, message: res?.message || 'Reward rejected successfully' };
        } catch (e) {
            return rejectWithValue(errMessage(e, 'Unable to reject reward'));
        }
    }
);

const initialState = {
    submitting: false,   // true while approve/reject request is in flight
    activeId: null,      // ledger id currently being processed
    error: null,
};

const rewardLedgerActionSlice = createSlice({
    name: 'rewardLedgerAction',
    initialState,
    reducers: {
        clearRewardActionError(state) {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        const pending = (state, action) => {
            state.submitting = true;
            state.activeId = action.meta.arg?.ledgerId ?? action.meta.arg;
            state.error = null;
        };
        const done = (state) => {
            state.submitting = false;
            state.activeId = null;
        };
        const failed = (state, action) => {
            state.submitting = false;
            state.activeId = null;
            state.error = action.payload || 'Something went wrong';
        };
        builder
            .addCase(approvePendingReward.pending, pending)
            .addCase(approvePendingReward.fulfilled, done)
            .addCase(approvePendingReward.rejected, failed)
            .addCase(rejectPendingReward.pending, pending)
            .addCase(rejectPendingReward.fulfilled, done)
            .addCase(rejectPendingReward.rejected, failed);
    },
});

export const { clearRewardActionError } = rewardLedgerActionSlice.actions;
export default rewardLedgerActionSlice.reducer;